import * as amplitude from "@amplitude/analytics-browser";

const API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

export function initAmplitude() {
  if (!API_KEY) {
    return;
  }

  amplitude.init(API_KEY, {
    autocapture: {
      elementInteractions: false,
      pageViews: false,
      sessions: true,
      formInteractions: false,
      fileDownloads: false,
    },
  });
}

export function identifyUser(userId, userProperties) {
  if (!API_KEY) return;

  amplitude.setUserId(userId);

  if (userProperties) {
    const identifyEvent = new amplitude.Identify();
    Object.entries(userProperties).forEach(([key, value]) => {
      identifyEvent.set(key, value);
    });
    amplitude.identify(identifyEvent);
  }
}

export function resetUser() {
  if (!API_KEY) return;
  amplitude.reset();
}

export function trackEvent(eventName, eventProperties) {
  if (!API_KEY) return;
  amplitude.track(eventName, eventProperties);
}

export function setUserProperties(properties) {
  if (!API_KEY) return;
  const identifyEvent = new amplitude.Identify();
  Object.entries(properties).forEach(([key, value]) => {
    identifyEvent.set(key, value);
  });
  amplitude.identify(identifyEvent);
}
